export default {
  "version.screen.modal.title": "スクリーン規格作成 / 編集",
  "version.screen.modal.onlinelabel": "ネット予約に表示するメッセージ（オプション）",
  "version.screen.modal.poslabel": "POSに表示するメッセージ（オプション）",
  "version.screen.modal.cclabel":"自動券売機に表示するメッセージ（オプション）",
  "version.screen.header.pos": "ポップアップ (POS)",
  "version.screen.header.net": "ポップアップ (ネット)",
  "version.screen.header.cc": "ポップアップ (自動券売機)",
  "version.screen.action.del": "削除しますか？",
  "version.others.modal.title": "その他バージョン作成 / 編集",
  "version.national.ticket.id": "バージョンID",
  "version.screen,header.signage": "サイネージ表示",
};